import React, { useState, useEffect } from 'react';
import './EventModal.css';

const EventModal = ({ isOpen, onClose, onSave, onDelete, selectedDate, event }) => {
  const [description, setDescription] = useState('');
  const [location, setLocation] = useState('');
  const [eventType, setEventType] = useState('practice');
  const [startDate, setStartDate] = useState('');
  const [startTime, setStartTime] = useState('19:00');
  const [endDate, setEndDate] = useState('');
  const [endTime, setEndTime] = useState('22:00');

  // Event type to title mapping
  const eventTitles = {
    'practice': 'Band Practice',
    'gig': 'Gig',
    'recording': 'Recording Session',
    'social': 'Social Event',
    'other': 'Other Event'
  };

  useEffect(() => {
    // If editing an existing event, populate the form
    if (event) {
      setDescription(event.description || '');
      setLocation(event.location || '');
      setEventType(event.eventType || 'practice');
      
      if (event.start) {
        const startDateTime = new Date(event.start);
        setStartDate(startDateTime.toISOString().split('T')[0]);
        setStartTime(startDateTime.toTimeString().slice(0, 5));
      }
      
      if (event.end) {
        const endDateTime = new Date(event.end);
        setEndDate(endDateTime.toISOString().split('T')[0]);
        setEndTime(endDateTime.toTimeString().slice(0, 5));
      }
    } else if (selectedDate) {
      // For new events, use the selected date
      setStartDate(selectedDate);
      setEndDate(selectedDate);
    }
  }, [event, selectedDate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate form
    if (!startDate || !startTime || !endDate || !endTime) {
      alert('Please fill in all required fields');
      return;
    }
    
    // Create event object with title derived from event type
    const eventData = {
      eventId: event ? event.id : `event-${Date.now()}`,
      title: eventTitles[eventType], // Use the event type as the title
      description,
      location,
      eventType,
      startTime: `${startDate}T${startTime}:00`,
      endTime: `${endDate}T${endTime}:00`,
      createdBy: 'band-member',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
    
    onSave(eventData);
  };

  const handleDelete = () => {
    if (window.confirm('Are you sure you want to delete this event?')) {
      console.log('Deleting event with ID:', event.id);
      onDelete(event.id);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>{event ? 'Edit Event' : 'Create New Event'}</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="eventType">Event Type:</label>
            <select 
              id="eventType" 
              value={eventType} 
              onChange={(e) => setEventType(e.target.value)}
            >
              <option value="practice">Band Practice</option>
              <option value="gig">Gig</option>
              <option value="recording">Recording Session</option>
              <option value="social">Social Event</option>
              <option value="other">Other</option>
            </select>
          </div>
          
          <div className="form-group">
            <label htmlFor="description">Description:</label>
            <textarea 
              id="description" 
              value={description} 
              onChange={(e) => setDescription(e.target.value)} 
              rows="3"
              placeholder="Optional details about the event"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="location">Location:</label>
            <input 
              type="text" 
              id="location" 
              value={location} 
              onChange={(e) => setLocation(e.target.value)} 
              placeholder="Where is this happening?"
            />
          </div>
          
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="startDate">Start Date:</label>
              <input 
                type="date" 
                id="startDate" 
                value={startDate} 
                onChange={(e) => setStartDate(e.target.value)} 
                required 
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="startTime">Start Time:</label>
              <input 
                type="time" 
                id="startTime" 
                value={startTime} 
                onChange={(e) => setStartTime(e.target.value)} 
                required 
              />
            </div>
          </div>
          
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="endDate">End Date:</label>
              <input 
                type="date" 
                id="endDate" 
                value={endDate} 
                onChange={(e) => setEndDate(e.target.value)} 
                required 
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="endTime">End Time:</label>
              <input 
                type="time" 
                id="endTime" 
                value={endTime} 
                onChange={(e) => setEndTime(e.target.value)} 
                required 
              />
            </div>
          </div>
          
          <div className="modal-footer">
            {event && (
              <button type="button" className="delete-button" onClick={handleDelete}>
                Delete Event
              </button>
            )}
            <div className="modal-footer-right">
              <button type="button" className="cancel-button" onClick={onClose}>Cancel</button>
              <button type="submit" className="save-button">Save Event</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EventModal;
